<script setup lang="ts">
interface Props {
  panelWidth: number;
  hasPanel?: boolean;
  isResizing?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  hasPanel: true,
  isResizing: false,
});

defineEmits<{
  dragStart: [event: PointerEvent];
}>();
</script>

<template>
  <div
    class="app-shell-left-menu"
    :class="{
      'is-resizing': props.isResizing,
      'has-panel': hasPanel,
      'is-collapsed': panelWidth === 0,
    }"
  >
    <div class="app-shell-left-menu__rail">
      <slot name="rail"></slot>
    </div>
    <div class="app-shell-left-menu__panel" v-if="hasPanel">
      <slot name="panel"></slot>
    </div>
    <div
      v-if="hasPanel"
      class="app-shell-left-menu__handle"
      aria-hidden="true"
      @pointerdown="$emit('dragStart', $event)"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.app-shell-left-menu {
  position: relative;
  display: grid;
  grid-template-columns: var(--layout-left-menu-collapsed-width) var(
      --layout-left-menu-panel-width
    );
  height: 100%;
  border-right: 1px solid $color-gray400;
  box-sizing: border-box;
  transition: grid-template-columns 160ms ease;
}

.app-shell-left-menu__rail {
  width: var(--layout-left-menu-collapsed-width);
  height: 100%;
  overflow: hidden auto;
  box-sizing: border-box;
}

.app-shell-left-menu.has-panel:not(.is-collapsed) .app-shell-left-menu__rail {
  border-right: 1px solid $color-gray400;
}

.app-shell-left-menu__panel {
  min-width: 0;
  height: 100%;
  overflow: hidden auto;
  --menu-item-width: 100%;
}

.app-shell-left-menu__handle {
  position: absolute;
  top: 0;
  right: -3px;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 100%;
  }

  &:hover::after {
    background: $color-green200;
  }
}

.app-shell-left-menu.is-resizing {
  transition: none;

  .app-shell-left-menu__handle::after {
    background: $color-green200;
  }
}
</style>
